import { createMuiStyles } from '../../../../utils/mui';

export const programDetailStyles = createMuiStyles({
  headerContent: {
    py: { xs: 3, lg: 5 },
    position: 'relative',
    '&::before': {
      content: '""',
      width: '100vw',
      bgcolor: 'grey.50',
      position: 'absolute',
      height: '100%',
      zIndex: -1,
      top: 0,
      display: 'block',
      left: 0,
    },
  },
  programStickyCardWrapper: {
    boxShadow: 10,
    borderRadius: '0.5rem',
    position: 'sticky',
    top: '6rem',
    maxHeight: 'calc(100vh - 8rem)',
    overflowY: 'auto',
    bgcolor: 'common.white',
  },
  programStickyCardAffiliation: {
    mt: 1,
    py: 1.5,
    px: 2,
    bgcolor: { xs: 'common.white', lg: 'grey.50' },
    borderRadius: '0.25rem',
    img: {
      height: '3.75rem',
      width: '3.75rem',
      objectFit: 'contain',
      display: 'block',
      borderRadius: '50%',
      border: 1,
      borderColor: 'divider',
    },
  },
  courseAccordion: {
    bgcolor: 'grey.50',
    borderRadius: '0.5rem',
    boxShadow: 'none',
  },
  courseAccordionSummary: {
    px: 2.5,
    flexDirection: 'row-reverse',
    '.MuiAccordionSummary-content': {
      my: `1.5rem!important`,
      ml: `.75rem!important`,
    },
  },
  courseAccordionDetail: {
    px: 2.5,
    pt: 0,
  },
  courseLink: {
    color: 'grey.800',
    fontWeight: 'Medium',
    '&:hover, &:focus': {
      color: 'primary.main',
    },
  },
});
